export const FIC_TYPES = [
  ["longfic", "Long-fic"], ["oneshot", "Oneshot"], ["drabble", "Drabble"], ["ficlet", "Ficlet"], ["headcanon", "Headcanon"], ["other", "Other"],
];
export const typeLabel = (w) => (w.kind !== "fanfiction" || !w.fic_type ? "" : w.fic_type === "other" ? w.fic_type_other || "Other" : FIC_TYPES.find(([k]) => k === w.fic_type)?.[1] || "");

export const localDay = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const wordsIn = (text) => (text.match(/\S+/g) || []).length;
export const fmt = (n) => (n || 0).toLocaleString("en-US");
export const edited = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

const doneKey = (day) => `lorely.goalDone.${day}`;
// True only the first time the goal is crossed on a given day
export const firstGoalHit = (today, goal) => {
  const day = localDay();
  if (today < goal || localStorage.getItem(doneKey(day))) return false;
  localStorage.setItem(doneKey(day), "1");
  return true;
};

export const RATINGS = [
  ["not_rated", "Not Rated", "border-slate-500/40 text-slate-300 bg-slate-500/10"],
  ["general", "General Audiences", "border-emerald-400/40 text-emerald-200 bg-emerald-500/10"],
  ["teen", "Teen And Up Audiences", "border-yellow-400/40 text-yellow-200 bg-yellow-500/10"],
  ["mature", "Mature", "border-orange-400/40 text-orange-200 bg-orange-500/10"],
  ["explicit", "Explicit", "border-rose-500/50 text-rose-200 bg-rose-500/10"],
];
export const RATING_SHORT = { not_rated: "NR", general: "G", teen: "T", mature: "M", explicit: "E" };
export const WARNINGS = [
  ["choose_not", "Choose Not To Use Archive Warnings"], ["violence", "Graphic Depictions Of Violence"], ["death", "Major Character Death"],
  ["none_apply", "No Archive Warnings Apply"], ["noncon", "Rape/Non-Con"], ["underage", "Underage Sex"],
];
export const EXCLUSIVE = ["choose_not", "none_apply"];
export const WORK_STATUS = {
  draft: ["Draft", "text-slate-300 border-slate-500/40"], in_progress: ["In progress", "text-sky-200 border-sky-400/40"],
  complete: ["Complete", "text-emerald-200 border-emerald-400/40"], hiatus: ["On hiatus", "text-violet-200 border-violet-400/40"],
};
export const CH_STATUS = [["in_progress", "In progress", "bg-sky-400"], ["unpublished", "Unpublished", "bg-amber-400"], ["published", "Published", "bg-emerald-400"]];
export const overallStatus = (hiatus, chapters) => {
  const pub = chapters.filter((c) => c.status === "published").length;
  return { status: hiatus ? "hiatus" : !pub ? "draft" : pub === chapters.length ? "complete" : "in_progress", published: pub };
};
export const hasWarnings = (w) => (w.warnings || []).some((x) => x !== "none_apply") || (w.custom_warnings || []).length > 0;

// Filter keys -> how to read the matching values off a work
const GET = {
  kind: (w) => [w.kind], fic_type: (w) => [w.fic_type], fandoms: (w) => w.fandoms, rating: (w) => [w.rating],
  warnings: (w) => [...w.warnings, ...w.custom_warnings], characters: (w) => w.characters, relationships: (w) => w.relationships,
  status: (w) => [w.status], chapter_status: (w) => w.chapter_statuses, tags: (w) => w.tags, world: (w) => [w.world_id || "none"],
};
export const FILTER_LABEL = {
  kind: "Kind", fic_type: "Type", fandoms: "Fandom", rating: "Rating", warnings: "Warning", characters: "Character",
  relationships: "Relationship", status: "Status", chapter_status: "Has chapters", tags: "Tag", world: "World",
};
const low = (a) => (a || []).map((x) => String(x ?? "").toLowerCase());
export const matches = (w, filters) => Object.entries(filters || {}).every(([k, vals]) => !vals?.length || !GET[k] || low(GET[k](w)).some((x) => low(vals).includes(x)));
export const searchHit = (w, q) => {
  const s = q.trim().toLowerCase();
  return !s || [w.title, ...w.tags, ...w.fandoms, ...w.characters, ...w.relationships].some((x) => x.toLowerCase().includes(s));
};
const ORDER_STATUS = ["draft", "in_progress", "complete", "hiatus"];
export const SORTS = [
  ["edited", "Last edited", (a, b) => b.updated_at.localeCompare(a.updated_at)],
  ["created", "Date created", (a, b) => b.created_at.localeCompare(a.created_at)],
  ["title", "Title A–Z", (a, b) => a.title.localeCompare(b.title)],
  ["words", "Word count", (a, b) => b.words - a.words],
  ["chapters", "Chapter count", (a, b) => b.chapter_count - a.chapter_count],
  ["rating", "Rating", (a, b) => RATINGS.findIndex((r) => r[0] === a.rating) - RATINGS.findIndex((r) => r[0] === b.rating)],
  ["status", "Status", (a, b) => ORDER_STATUS.indexOf(a.status) - ORDER_STATUS.indexOf(b.status)],
  ["fandom", "Fandom", (a, b) => (a.fandoms[0] || "\uffff").localeCompare(b.fandoms[0] || "\uffff")],
];
export const sortWorks = (list, key) => [...list].sort(SORTS.find((s) => s[0] === key)?.[2] || SORTS[0][2]);
export const inCollection = (w, c) => (c.kind === "manual" ? c.work_ids.includes(w.id) : matches(w, c.filters));
